
import React from "react";
import { TrendingUp } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { intermediateTierSchema } from "@/contexts/program-creation/types";

interface ProgressChallengesSectionProps {
  form: UseFormReturn<z.infer<typeof intermediateTierSchema>>;
}

export default function ProgressChallengesSection({ form }: ProgressChallengesSectionProps) {
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-2 text-white/90 border-b border-white/20 pb-2">
        <TrendingUp size={18} />
        <h4 className="font-medium">Progress & Challenges</h4>
      </div>
      
      <FormField
        control={form.control}
        name="plateaus"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              Have they hit any plateaus or seen slow progress in certain areas? If yes, please describe.
            </FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Bench press has been stuck at 80kg for three months. Struggling to progress on barbell rows." 
                className="bg-white/20 border-white/30 text-white min-h-[80px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="performanceMetrics"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              Do they track any personal bests (PRs) or performance markers? If so, list one or two.
            </FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Squat max: 100kg, Deadlift: 125kg for 5 reps" 
                className="bg-white/20 border-white/30 text-white min-h-[80px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
